import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useMainService = (serviceId) => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["mainService", serviceId, tenantVal],
    queryFn: async () => {
      if (!serviceId) return null;

      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/practiceservice/get/${serviceId}`
      );
      return response.data;
    },
    enabled: !!serviceId,
    meta: { errorMessage: "Error fetching main service" },
  });
};
